import React, { useState } from 'react';
import { Languages } from 'lucide-react';
const AuthLayout = ({
  children,
  title
}) => {
  const [language, setLanguage] = useState('EN');
  return <div className="min-h-screen bg-blue-50" data-id="element-29">
      {/* Top bar with logo */}
      <div className="bg-gradient-to-r from-[#0a1e3d] via-[#0d3d5c] to-[#1a7a8a] border-b-2 border-blue-600/30 shadow-xl" data-id="element-30">
        <div className="max-w-7xl mx-auto px-2 py-8" data-id="element-31">
          <div className="flex items-center justify-between" data-id="element-32">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/joxaMU5tLrDxL7uEJiHC9V/AISCO_WORKSPACE_MARCA_NEGATIVO.svg" alt="Logo" className="h-8" data-id="element-33" />

            {/* Language selector */}
            <div className="relative" data-id="element-34">
              <select value={language} onChange={e => setLanguage(e.target.value)} className="appearance-none bg-white/10 text-white border border-white/20 rounded-lg px-4 py-2 pr-10 text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-white/30" data-id="element-35">
                <option value="EN" className="bg-gray-800" data-id="element-36">
                  English
                </option>
                <option value="ES" className="bg-gray-800" data-id="element-37">
                  Español
                </option>
                <option value="FR" className="bg-gray-800" data-id="element-38">
                  Français
                </option>
                <option value="DE" className="bg-gray-800" data-id="element-39">
                  Deutsch
                </option>
                <option value="IT" className="bg-gray-800" data-id="element-40">
                  Italiano
                </option>
                <option value="PT" className="bg-gray-800" data-id="element-41">
                  Português
                </option>
              </select>
              <Languages className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white pointer-events-none" data-id="element-42" />
            </div>
          </div>
        </div>
      </div>

      {/* Form side with centered content */}
      <div className="w-full flex items-center justify-center p-8" data-id="element-43">
        <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-sm" data-id="element-44">
          <div className="text-center mb-8" data-id="element-45">
            <h1 className="text-3xl font-bold text-gray-900 mb-2 tracking-tight" data-id="element-46">
              {title}
            </h1>
            <div className="h-1 w-10 bg-blue-600 mx-auto rounded-full mt-2" data-id="element-47"></div>
          </div>
          {children}
        </div>
      </div>
    </div>;
};
export default AuthLayout;